import { Component, OnInit } from '@angular/core';
import { MyDocReviewService } from './my-doc-review.service';
import { LabelConstants } from '../shared/constants/label-constants';

@Component({
  selector: 'app-my-doc-review',
  templateUrl: './my-doc-review.component.html',
  styleUrls: ['./my-doc-review.component.scss']
})
export class MyDocReviewComponent implements OnInit{

topBarTitle:string = "My Doc Review";
showAllLabel:string="Show All";
isIncludeInactive = false;
showInformationIconCheckbox = true;
inactiveTooltip:string = "By default only In Review Document Versions with your Pending Reviews are displayed. Check this check box to display all the Document Version where you are assigned as Reviewer, regardless of any other condition.";
documentSearchResult:any[] = [];
showLoader: boolean = true;
isScreenAccessible : boolean = true;
errorMessage !: string;

constructor(private myDocReviewService:MyDocReviewService){ 
}

ngOnInit(): void {
  this.getPanelListData(this.isIncludeInactive);
}

    includeInactive(isIncludeInactive: boolean) {
        this.showLoader = true;
  this.getPanelListData(isIncludeInactive);
}

getPanelListData(isIncludeInactive:boolean){
    this.myDocReviewService.getMyDocReviews(isIncludeInactive).subscribe({
        error: (err) => {
            if (err.status === LabelConstants.Forbidden_StatusCode) {
                this.errorMessage = err.error.detail;
            }
            this.isScreenAccessible = false
        },
        next: (serviceData) => {
            this.documentSearchResult = serviceData;
            this.showLoader = false;
        }
  });
}
}
